import { render, staticRenderFns } from "./SetCategory.vue?vue&type=template&id=22b65770&"
import script from "./SetCategory.vue?vue&type=script&lang=js&"
export * from "./SetCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports